import { ThemeProvider } from "@mui/material/styles";
import { createMuiTheme } from "@config/theme/mui-theme";
import type { ReactNode } from "react";

const theme = createMuiTheme("light");

export function MUIThemeProvider({ children }: { children: ReactNode }) {
	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
